import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Dropdown, Badge, Tooltip } from 'antd';
import {
  UserOutlined,
  LogoutOutlined,
  BellOutlined,
  DashboardOutlined
} from '@ant-design/icons';
import { useAuth } from '../context/AuthContext';
import { useSelector } from 'react-redux';
import './Navigation.css';

function Navigation() {
  const { isAuthenticated, logout } = useAuth();
  const { user } = useSelector(state => state.auth);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleMenuClick = ({ key }) => {
    switch (key) {
      case 'profile':
        navigate('/profile');
        break;
      case 'logout':
        handleLogout();
        break;
      default:
        break;
    }
  };

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: 'My Profile',
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
      danger: true,
    },
  ];

  return (
    <nav className="navigation">
      {isAuthenticated ? (
        <>
          {/* Left Section - Quick Actions */}
          <div className="nav-left">
            <Tooltip title="Dashboard">
              <button className="nav-icon-btn" onClick={() => navigate('/dashboard')}>
                <DashboardOutlined />
              </button>
            </Tooltip>
          </div>

          {/* Right Section - User Actions */}
          <div className="nav-right">
            {/* Notifications */}
            <Tooltip title="Notifications">
              <Badge count={0} showZero={false}>
                <button className="nav-icon-btn">
                  <BellOutlined />
                </button>
              </Badge>
            </Tooltip>

            {/* User Menu */}
            <Dropdown
              menu={{
                items: userMenuItems,
                onClick: handleMenuClick,
              }}
              trigger={['click']}
              placement="bottomRight"
            >
              <div className="user-menu-trigger">
                <div className="user-avatar-nav">
                  <UserOutlined />
                </div>
                <div className="user-info-nav">
                  <span className="user-name-nav">{user?.username || 'User'}</span>
                  <span className="user-role-nav">{user?.role || 'Member'}</span>
                </div>
              </div>
            </Dropdown>
          </div>
        </>
      ) : (
        <div className="nav-guest">
          <Link to="/login" className="nav-link-guest">Login</Link>
          <Link to="/signup" className="nav-link-guest primary">Sign Up</Link>
        </div>
      )}
    </nav>
  );
}

export default Navigation;